module.exports = __webpack_public_path__ + "static/EM3-23914742d42008921acd95407815a1cf.jpg";